// extracted by mini-css-extract-plugin
export default {"service":"ServiceIcon_service__R6zWe"};